import styled from '@emotion/styled';

import { font } from '../../../Font/Font.styles';

export const StyledButton = styled.button`
  ${font('body-lg')};
  padding: 0;
  color: var(--color-black);
  border: none;
  background: none;
  cursor: pointer;
  text-decoration: underline;
  position: relative;

  @media (min-width: 769px) {
    text-decoration: none;

    &::before {
      content: '';
      position: absolute;
      display: block;
      width: 100%;
      height: 1px;
      bottom: 0;
      left: 0;
      background-color: var(--color-black);
      transform: scaleX(1);
      transition: transform 0.3s ease;
    }

    &:hover::before {
      transform: scaleX(0);
    }
  }
`;
